import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

import { normalizeRid } from '../../../shared/model/scopeKeys'
import { EMPTY_VIEW, type StructureIntentState, type StructureViewState } from './types'

/**
 * Намерение человека на экране «Структура 1С» по каждой базе: поиск, свёрнутые
 * узлы и выбранный узел. Сама структура — ответ службы — живёт в кэше RTK
 * Query и сюда не кладётся (R01).
 */
const initialState: StructureIntentState = {}

const viewOf = (state: StructureIntentState, resourceId: string): StructureViewState => {
  const rid = normalizeRid(resourceId)
  state[rid] ??= { ...EMPTY_VIEW, collapsed: [] }
  return state[rid]
}

const structureSlice = createSlice({
  name: 'onec/structure',
  initialState,
  reducers: {
    structureSearchChanged(state, action: PayloadAction<{ resourceId: string; search: string }>) {
      viewOf(state, action.payload.resourceId).search = action.payload.search
    },
    structureNodeToggled(state, action: PayloadAction<{ resourceId: string; id: string }>) {
      const view = viewOf(state, action.payload.resourceId)
      const id = action.payload.id.toLowerCase()
      view.collapsed = view.collapsed.includes(id) ? view.collapsed.filter((item) => item !== id) : [...view.collapsed, id]
    },
    structureNodeSelected(state, action: PayloadAction<{ resourceId: string; id: string }>) {
      const view = viewOf(state, action.payload.resourceId)
      const id = action.payload.id.toLowerCase()
      view.selected = view.selected === id ? null : id
    },
  },
})

export const { structureSearchChanged, structureNodeToggled, structureNodeSelected } = structureSlice.actions
export const structureReducer = structureSlice.reducer
